import { PlanInputSchema } from '@weft/types';
import type { oz } from '@weft/utils';

export const SoftUpdatePlanRequestSchema = PlanInputSchema.pick({
  name: true,
  billingData: true,
}).openapi('SoftUpdatePlanRequest');

export type SoftUpdatePlanRequestPayload = oz.infer<typeof SoftUpdatePlanRequestSchema>;